import { Spin } from 'antd'
import React, { useContext } from 'react'
import { ConfigContext } from '@/utils/contextStatic'
import { InterimManageStyle } from './styled'
import Text from '@/components/Text'


const InterimManage:React.FC = ()=> {

	const { isPC }:any = useContext(ConfigContext)

	// 加载中
  const loaderRender = () => {
    return (
			<Spin size={isPC ? 'large' : 'default'} tip={<Text type='english' size={isPC ? '16' : '14'} color='gray600'>Loading...</Text>} >
				<i></i>
			</Spin>
		)
  }

  return (
		<InterimManageStyle>
			<div className='form-bar'>{loaderRender()}</div>
			<div className='reward-bar'>
				<div>{loaderRender()}</div>
				<div>{loaderRender()}</div>
			</div>
		</InterimManageStyle>
  )
}

export default InterimManage
